module.exports = __webpack_public_path__ + "media/images/hero/glyph-d1-b5409b2bc238432279177b69648a74e9.svg";